export default __webpack_public_path__ + "static/media/house-5.c8d044d9.jpg";